import { Box, Typography } from '@mui/material';

import { convertToKebabCase } from '../../../constants/helpers/text';

interface Props {
  label: string;
  value: string;
}

const DetailsItem = ({ label, value }: Props) => (
  <Box data-testid={`${convertToKebabCase(label)}-details`} mb={2} mt={2}>
    <Typography variant="body1">{label}</Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

export default DetailsItem;
